import React from "react";

interface Props {}

export const AppVersion: React.FunctionComponent<Props> = () => {
  return <span>{process.env.REACT_APP_BUILD_VERSION || "dev-build"}</span>;
};
